import { BaseTestimonial } from "./BaseTestimonial";

export class TestimonialDetailModel extends BaseTestimonial {
    constructor(data) {
        super(data);

        this.tags = data.tags;

        this.description = data.description;
    }
}
